@if (groupList.length) {
  <p-select
    [options]="groupList"
    [multiple]="true"
    [filter]="true"
    filterBy="label"
    [ngModel]="selectedUserGroups"
    (ngModelChange)="selectedUserGroups = $event; onGroupChange($event)"
    appendTo="body"
    panelStyleClass="p-select-checkbox-options"
    placeholder="User role"
    [lazy]="true"
    dataKey="id"
  >
    <ng-template #item let-option>
      <p-checkbox
        [ngModel]="isSelected(option.value)"
        [binary]="true"
        [readonly]="true"
        [tabindex]="-1"
      />
      <span>{{ option.label }}</span>
    </ng-template>

    <ng-template #selectedItem>
      <app-selected-chips
        [items]="selectedUserGroups"
        [label]="chipLabel"
        [key]="chipKey"
        [removable]="true"
        (removeItem)="removeGroup($event)"
      />
    </ng-template>
  </p-select>
}
